import CardList from "./list";


if (document.body.getAttribute("data-current-path") === "cards") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new CardList();
    }
}